import { Component, Vue, Watch } from "vue-property-decorator";
import { Form, Input, Button, Alert } from "ant-design-vue";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { getRouteAccessLevel, isAnyVersionSelected } from "@/util/func";
import {
	WordSpecsReportManagerService,
	WordSpecsReportResponseModel,
	WordSpecsReportRequestParamsModel
} from "@/services/text-writer/word-specs";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import { CommonLocale, WordSpecLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import PageTitle from "@/components/page-title/page-title.vue";
import { AccessLevel } from "@/util/enum";

@Component({
	components: {
		Form,
		FormItem: Form.Item,
		TextArea: Input.TextArea,
		Grid,
		Button,
		Alert,
		PageTitle
	}
})
export default class WordSpec extends Vue {
	private wordSpecsService = WordSpecsReportManagerService();
	public inputText: string = "";
	public loading: boolean = false;
	public itemSource: WordSpecsReportResponseModel[] = [];
	public noVersion: boolean = false;
	private versionGroupModule = VersionGroupModule; // For watch need to create local reference
	public titleListModule = getModule(TitleListState);
	public format = fmtMsg;
	public locale = WordSpecLocale;
	public commonLocale = CommonLocale;
	public form;
	public accessLevel = AccessLevel;

	created() {
		this.form = this.$form.createForm(this, { name: "form" });
	}

	mounted() {
		this.versionGroupModule.setDisabled(false);
		if (!isAnyVersionSelected()) {
			this.noVersion = true;
		}
	}

	destroyed() {
		this.versionGroupModule.setDisabled(true);
	}

	@Watch("versionGroupModule.selectedGsVersion", { immediate: true })
	GsVersionUpdatedIm() {
		if (!isAnyVersionSelected()) {
			this.noVersion = true;
		} else {
			this.noVersion = false;
		}
	}

	@Watch("versionGroupModule.selectedGsVersion")
	GsVersionUpdated() {
		if (isAnyVersionSelected()) {
			this.noVersion = false;
		}
	}

	@Watch("versionGroupModule.selectedLsVersion")
	LsVersionUpdated() {
		if (!isAnyVersionSelected()) {
			this.noVersion = true;
		} else {
			this.noVersion = false;
		}
	}

	get exportOptions() {
		return {
			filename: fmtMsg(WordSpecLocale.WordSpecExportTitle)
		};
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	fetchWordCountReport(e) {
		if (e) {
			e.preventDefault();
		}

		this.loading = true;
		const params: WordSpecsReportRequestParamsModel = {
			searchWords: this.inputText,
			gsVersionGroupId:
				VersionGroupModule.selectedGsVersion !== "-1" ? VersionGroupModule.selectedGsVersion : null,
			lsVersionGroupId:
				VersionGroupModule.selectedLsVersion !== "-1" ? VersionGroupModule.selectedLsVersion : null
		};

		return this.wordSpecsService.getWordSpecsReport(params).then((data) => {
			this.itemSource = data;
			this.loading = false;
			return Promise.resolve();
		});
	}
}
